export default {
  "userVipAdmin.thead.index": "#序号",
  "userVipAdmin.thead.documentId": "DocumentId",
  "userVipAdmin.thead.title": "等级名称",
  "userVipAdmin.thead.levelValue": "等级",
  "userVipAdmin.thead.levelAmount": "晋级经验值要求",
  "userVipAdmin.thead.bonusValue": "晋级礼金",
  "userVipAdmin.thead.weeklyBonus": "每周返现",
  "userVipAdmin.thead.monthlyBonus": "每月返现",
  "userVipAdmin.thead.withdrawTimesLimit": "提现次数限制",
  "userVipAdmin.thead.withdrawAmountLimit": "提现金额限制",
  "userVipAdmin.thead.weeklyCashbackConf": "每周返现配置",
  "userVipAdmin.thead.monthlyCashbackConf": "每月返现配置",
  "userVipAdmin.thead.promotionCashbackConf": "晋级返现配置",
  "userVipAdmin.thead.cashbackAmountType": "奖励金类型",
  "userVipAdmin.thead.cashbackValue": "奖励金",
  "userVipAdmin.thead.cashbackWithdrawLimit": "流水倍率",
  "userVipAdmin.thead.cashbackExpire": "奖励过期小时数",
  "userVipAdmin.thead.startTime": "奖励达成后(x)小时可领取",
  "userVipAdmin.add": "新增",
  "userVipAdmin.edit": "编辑",
  "userVipAdmin.details": "详情",
  "userVipAdmin.delete": "删除",

  "userVipAdmin.thead.status": "状态",
  "userVipAdmin.thead.createdAt": "创建时间",
  "userVipAdmin.thead.updatedAt": "修改时间",
  "userVipAdmin.thead.action": "操作",
};
